import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { AddEditProjectStage, ProjectHeader, ProjectStages } from "../../components/project";
import { useHasPermission } from "../../utils";
import { CREATE_STAGE } from "../../constants";

export const ProjectStage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasCreateStage = useHasPermission(CREATE_STAGE);

  const reloadProjectStages = () => {
    setReload((prev) => prev + 1);
  };

  const buttons = [
    hasCreateStage && { icon: <Add />, buttonText: "Add Stage", tooltip: "Add Stage", onClick: () => setOpenModal(true) },
  ];
  return (
    <>
      <PageLayout>
        <Box sx={{ position: "relative", zIndex: 1, marginTop: "22px" }}>
          <ProjectHeader title="Project Stages" actionButtons={buttons} />
        </Box>
        <ProjectStages reloadData={reload} />
      </PageLayout>

      {/* add stage modal */}
      <AddEditProjectStage open={openModal} onClose={() => setOpenModal(false)} onSuccess={reloadProjectStages} />
    </>
  );
};
